import { z } from "zod";

import { refsSchema } from "./refsSchema.ts";

const configSchema = z.record(z.unknown()).and(
  z.object({
    refs: refsSchema.optional(),
  }),
);

type Config = z.infer<typeof configSchema>;

export interface ConditionBuild {
  id: number; // instance
  nodeId?: number; // source; where the buildable came from (not necessarily host node!)
  buildableName: string; // from this (along with node id) typeId and spec can be obtained (if node designer still returning it).
  config: Config;
  children: Record<string, ConditionBuild | ConditionBuild[] | undefined>;
}

export const conditionBuildWithoutChildrenSchema = z.object({
  id: z.number().int(),
  nodeId: z.number().optional(),
  buildableName: z.string(),
  config: configSchema,
});

export type ConditionBuildWithoutChildren = z.infer<typeof conditionBuildWithoutChildrenSchema>;

export const conditionBuildSchema: z.ZodType<ConditionBuild> = z.lazy(() =>
  conditionBuildWithoutChildrenSchema.extend({
    children: z.record(z.string(), z.union([conditionBuildSchema, z.array(conditionBuildSchema), z.undefined()])),
  }),
);

export type EffectBuild = z.infer<typeof effectBuildSchema>;

export const effectBuildSchema = z.object({
  id: z.number().int(), // instance
  nodeId: z.number().int(), // source; where the buildable came from (not necessarily host node!)
  targetNodeId: z.number().int().optional(), // node it is an effect on (action target). if not specified then nodeId implied
  buildableName: z.string(), // from this (along with node id) typeId and spec can be obtained (if node designer still returning it).
  config: configSchema,
});

export const triggerConditionBuildSchema = z.object({
  config: configSchema,
});

export type TriggerConditionBuild = z.infer<typeof triggerConditionBuildSchema>;
